import { all, call, put, takeLatest } from "redux-saga/effects"
import API from "../../helpers/sagaApi/sagaApi"
import Actions, { SagaContactTypes } from "./sagaContactRedux"
import AppConfig from "../../configs/AppConfig"
import { confirmClearCart, successModal } from "../../helpers/utility"
import { getJwtToken } from "../sagaAuth/sagaAuthSaga"

export function* requestCreateHisobusContact(action) {
  const tag = "[REQUEST_CREATE_HISOBUS_CONTACT]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCreateHisobusContact,
        action.contact
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCreateHisobusContact response :`,
            response.data
          )
        }
        yield put(Actions.createHisobusContactSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreateHisobusContact failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createHisobusContactFailure(message))
  }
}

export function* requestCreatePartnerRequest(action) {
  const tag = "[REQUEST_CREATE_PARTNER_REQUEST]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCreatePartnerRequest,
        action.request
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCreatePartnerRequest response :`,
            response.data
          )
        }
        yield put(Actions.createPartnerRequestSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreatePartnerRequest failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createPartnerRequestFailure(message))
  }
}

export function* requestCreateBusinessRegister(action) {
  const tag = "[REQUEST_CREATE_BUSINESS_REGISTER]"
  try {
    // step 1: perform input validation
    const inputValid = true // IDE-Help, do not delete me
    if (inputValid) {
      // step 2 : validation passed..
      const response = yield call(
        API.requestCreateBusinessRegister,
        action.business
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCreateBusinessRegister response :`,
            response.data
          )
        }
        yield put(Actions.createBusinessRegisterSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreateBusinessRegister failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createBusinessRegisterFailure(message))
  }
}

export function* requestGetAssuerInfo(action) {
  const tag = "[REQUEST_GET_ASSUER_INFO]"
  try {
    if (true) {
      const response = yield call(
        API.requestGetAssuerInfo,
        action.bookingID,
        action.refId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestGetAssuerInfo response :`, response.data)
        }
        yield put(Actions.getAssuerInfoSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetAssuerInfo failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getAssuerInfoFailure(message))
  }
}

export function* requestCreateAssuer(action) {
  const tag = "[REQUEST_CREATE_ASSUER]"
  try {
    const inputValid = true
    if (inputValid) {
      const response = yield call(API.requestCreateAssuer, action.assurerReq)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestCreateAssuer response :`, response.data)
        }
        yield put(Actions.createAssuerSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreateAssuer failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createAssuerFailure(message))
  }
}

export function* requestGetAssurerGets(action) {
  const tag = "[REQUEST_GET_ASSURER_GETS]"
  try {
    const jwtToken = yield getJwtToken() // IDE-Help, do not delete me
    if (jwtToken) {
      const response = yield call(
        API.requestGetAssurerGets,
        jwtToken,
        action.bookingNo
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(`${tag} requestGetAssurerGets response :`, response.data)
        }
        yield put(Actions.getAssurerGetsSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetAssurerGets failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.getAssuerInfoFailure(message))
  }
}

export function* requestDeleteAssurerGets(action) {
  const tag = "[REQUEST_DELETE_ASSURER_GETS]"
  try {
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      const response = yield call(
        API.requestDeleteAssurerGets,
        jwtToken,
        action.id,
        action.bookingId
      )
      if (response.status === 200 && response.data.statusCode === 200) {
        console.log(`${tag} requestDeleteAssurerGets response :`, response.data)
        yield put(Actions.deleteAssurerGetsSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestDeleteAssurerGets failed with error :`, e)
    // errorModal("Connent Server Error", "The system is under construction")
    const message = e.message ? e.message : "Failed"
    yield put(Actions.deleteBlogFailure(message))
  }
}

export function* requestGetCountries(action) {
  const tag = "[REQUEST_GET_COUNTRIES]"
  try {
    // const jwtToken = yield getJwtToken()
    // if (jwtToken) {
    const inputValid = true
    if (inputValid) {
      const response = yield call(API.requestGetCountries, null)
      if (response.status === 200 && response.data.statusCode === 200) {
        console.log(`${tag} requestGetCountries response :`, response.data)
        yield put(Actions.getCountriesSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestGetCountries failed with error :`, e)
    // errorModal("Connent Server Error", "The system is under construction")
    const message = e.message ? e.message : "Failed"
    yield put(Actions.deleteBlogFailure(message))
  }
}

export function* requestCreateEmployee(action) {
  const tag = "[REQUEST_CREATE_EMPLOYEE]"
  try {
    const inputValid = true
    if (inputValid) {
      const response = yield call(API.requestCreateEmployee, action.employeeReq)
      if (response.status === 200 && response.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          successModal(
            "โทร 02-0803972",
            "ขอบคุณที่ได้ให้ความไว้วางใจ เจ้าหน้าที่บริการลูกค้า Hisobus จะดำเนินการติดต่อกลับท่านภายใน 24 ชม."
          )
          console.log(`${tag} requestCreateEmployee response :`, response.data)
        }
        yield put(Actions.createEmployeeSuccess(response.data.result))
      } else {
        throw new Error(response.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCreateEmployee failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.createEmployeeFailure(message))
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      SagaContactTypes.REQUEST_CREATE_HISOBUS_CONTACT,
      requestCreateHisobusContact
    ),
    takeLatest(
      SagaContactTypes.REQUEST_CREATE_PARTNER_REQUEST,
      requestCreatePartnerRequest
    ),
    takeLatest(
      SagaContactTypes.REQUEST_CREATE_BUSINESS_REGISTER,
      requestCreateBusinessRegister
    ),
    takeLatest(SagaContactTypes.REQUEST_GET_ASSUER_INFO, requestGetAssuerInfo),
    takeLatest(SagaContactTypes.REQUEST_CREATE_ASSUER, requestCreateAssuer),
    takeLatest(
      SagaContactTypes.REQUEST_GET_ASSURER_GETS,
      requestGetAssurerGets
    ),
    takeLatest(
      SagaContactTypes.REQUEST_DELETE_ASSURER_GETS,
      requestDeleteAssurerGets
    ),
    takeLatest(SagaContactTypes.REQUEST_GET_COUNTRIES, requestGetCountries),
    takeLatest(SagaContactTypes.REQUEST_CREATE_EMPLOYEE, requestCreateEmployee)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagaContact/sagaContactSaga.ts